import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 导入路由配置
import http from './util/http'
import elementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import topTitle from './components/TopTitle.vue';
import './assets/global.css'
const app = createApp(App);
app.config.globalProperties.$http = http;
app.component('TopTitle', topTitle);
app.use(router); // 挂载路由
app.use(elementPlus)
app.mount('#app');